import React from "react";

import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import CategoriesNav from "./CategoriesNav";
import FilterAndSort from "./FilterAndSort";
import FilterMenu from "./FilterMenu";
import Metatags from "../components/Metatags";
import getConfig from "../core/config";
import Head from "next/head";
import { useRouter } from "next/router";

import Spinner from "./Spinner";

import ListingsContextProvider from "./ListingsContext";
import FilteredProducts from "./FilteredProducts";

function Listings({ category, brand, isLatestDrop }) {
  const rootCategory = category.rootCategoryTree;

  if (!isLatestDrop && !rootCategory) {
    console.log("No root category found", category);
    return (
      <Box mt={[24, null, 42, null]}>
        <Spinner />
      </Box>
    );
  }

  const title = `Reskinned${brand ? ` x ${brand.name}` : ""} | Pre-Loved ${
    category.name
  }`;

  const collectionSeoTitle = `${brand ? `${brand.name} ` : ""}${
    rootCategory ? rootCategory.name : ""
  }${
    rootCategory && rootCategory.name !== category.name
      ? ` ${category.name}`
      : ""
  }`;

  const router = useRouter();

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="canonical" href={`${getConfig("ORIGIN")}${router.asPath}`} />
      </Head>
      <Metatags
        metaTitle={`${collectionSeoTitle}: New & Pre-loved On Sale Up To 60% Off RRP`}
        metaDescription={`${collectionSeoTitle}${
          isLatestDrop ? "" : " For Sale"
        } - Discover Quality Pre-Loved Fashion and New Clothing. Find quality pre-loved pieces at great prices - better for the planet and your wallet, with ozone-cleansed items and 30-day returns.`}
      />
      <ListingsContextProvider
        category={category}
        brandSlug={brand ? brand.slug : null}
        isLatestDrop={isLatestDrop}
      >
        <FilterMenu rootCategory={rootCategory} />
        <CategoriesNav
          brand={brand}
          isLatestDrop={isLatestDrop}
          category={category}
        />
        <Box mt={[24, null, 42, null]}>
          <FilterAndSort />
          <BoxWithGutter
            my={[16, null, 26, null]}
            minHeight={[null, null, 500, null]}
            display="flex"
            flexDirection="column"
          >
            <Box flex="1">
              <FilteredProducts brand={brand} isLatestDrop={isLatestDrop} />
            </Box>
          </BoxWithGutter>
        </Box>
      </ListingsContextProvider>
    </>
  );
}

export default Listings;
